export default __webpack_public_path__ + "static/media/pepsiman.fcba69f9.png";